import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import langLocalesData from './langconfig.json';

const lang = getLanguageByPath();
const footerLocales = langLocalesData[lang]?.common_footer;

const PROTOCOL = {
  en: {
    cookie: '//www.mechabreak.com/show-1034-35-1.html',
    privacy: '//mechabreak.seasungames.com/show-1034-211-1.html',
    service: '//mechabreak.seasungames.com/show-1034-561-1.html'
  },
  ja: {
    cookie: '//www.mechabreak.com/show-1031-36-1.html',
    privacy: '//mechabreak.seasungames.com/show-1033-209-1.html',
    service: '//mechabreak.seasungames.com/show-1033-210-1.html'
  },
  ko: {
    cookie: '//www.mechabreak.com/show-1031-37-1.html',
    privacy: '//mechabreak.seasungames.com/show-1032-40-1.html',
    service: '//mechabreak.seasungames.com/show-1032-208-1.html'
  },
  'zh-Hant': {
    cookie: '//www.mechabreak.com/show-1031-34-1.html',
    privacy: '//mechabreak.seasungames.com/show-1031-205-1.html',
    service: '//mechabreak.seasungames.com/show-1031-206-1.html'
  },
  es: {
    cookie: '//www.mechabreak.com/show-1094-147-1.html',
    privacy: '//mechabreak.seasungames.com/show-1094-148-1.html',
    service: '//mechabreak.seasungames.com/show-1094-149-1.html'
  },
  pt: {
    cookie: '//www.mechabreak.com/show-1095-152-1.html',
    privacy: '//mechabreak.seasungames.com/show-1095-151-1.html',
    service: '//mechabreak.seasungames.com/show-1095-150-1.html'
  },
  de: {
    cookie: '//www.mechabreak.com/show-1096-156-1.html',
    privacy: '//mechabreak.seasungames.com/show-1096-155-1.html',
    service: 'https://mechabreak.seasungames.com/show-1096-154-1.html'
  },
  fr: {
    cookie: '//www.mechabreak.com/show-1097-160-1.html',
    privacy: '//mechabreak.seasungames.com/show-1097-159-1.html',
    service: '//mechabreak.seasungames.com/show-1097-158-1.html'
  },
  ru: {
    cookie: '//www.mechabreak.com/show-1098-164-1.html',
    privacy: '//mechabreak.seasungames.com/show-1098-163-1.html',
    service: '//mechabreak.seasungames.com/show-1098-162-1.html'
  },
  th: {
    cookie: '//mechabreak.seasungames.com/p/zt/2025/06/07/article-template/?contentId=m_mb_1034_324&lang=th#/',
    privacy: '//mechabreak.seasungames.com/show-1238-244-1.html ',
    service: '//mechabreak.seasungames.com/show-1238-242-1.html'
  }
};

// 默认协议跳转配置
const links = [
  {
    href: PROTOCOL[lang].cookie,
    text: footerLocales.cookie_agreement,
    name: 'Cookie协议'
  },
  {
    href: null,
    text: footerLocales.cookie_setting,
    cookieSetting: true,
    name: 'Cookie设定 开关'
  },
  {
    href: PROTOCOL[lang].privacy,
    text: footerLocales.privacy_policy,
    isFontWeight: lang === 'ko',
    name: '隐私权政策'
  },
  {
    href: PROTOCOL[lang].service,
    text: footerLocales.right_of_useAgreement,
    name: '使用权协议'
  }
];

const footerTopLogo = [
  {
    img: require('./images/logo.png'),
    url: 'https://www.seasungames.com/m/index.html',
    name: 'seasunGames Logo'
  }
];

const Config = {
  /**
   * 配置项，根据语言进行分组
   */
  en: {
    footerLeftLogo: [
      // {
      //   img: require('./images/en/seal.png'),
      //   url: '//privacy.trustarc.com/privacy-seal/validation?rid=93307ef1-92cf-49a1-8876-511ff47907e4'
      // },
      {
        img: require('./images/en/iarc.png'),
        url: ''
      }
    ],
    footerTopLogo,
    agreementLinks: links
  },
  ja: {
    footerLeftLogo: [
      // {
      //   img: require('./images/ja/seal.png'),
      //   url: '//privacy.trustarc.com/privacy-seal/validation?rid=08441dad-ade0-4d1e-8db6-0308f3c94a32&lang=ja'
      // },
      {
        img: require('./images/ja/iarc.png'),
        url: ''
      }
    ],
    // 日语特殊协议 新增两个链接
    agreementLinks: [
      ...links,
      {
        href: 'https://www.amazingseasun.com/show-1356-180-1.html',
        text: footerLocales.funds_ja
      },
      {
        href: 'https://www.amazingseasun.com/show-1356-179-1.html',
        text: footerLocales.acquisition_ja
      }
    ],
    footerTopLogo
  },
  ko: {
    footerLeftLogo: [
      // {
      //   img: require('./images/ko/seal.png'),
      //   url: '//privacy.trustarc.com/privacy-seal/validation?rid=cd4c49da-fab8-4a91-bfaa-f7f2b89cf362&lang=ko'
      // },
      {
        img: require('./images/ko/iarc.png'),
        url: ''
      }
    ],
    footerTopLogo,
    agreementLinks: links
  },
  'zh-Hant': {
    footerLeftLogo: [
      {
        img: require('./images/zh-Hant/seal.png'),
        url: ''
      }
    ],
    footerTopLogo: [
      ...footerTopLogo,
      {
        img: require('./images/hai_logo.png')
      }
    ],
    agreementLinks: links
  },
  es: {
    footerLeftLogo: [
      // {
      //   img: require('./images/es/seal.png'),
      //   url: '//privacy.trustarc.com/privacy-seal/validation?rid=d5bdbf52-2dd2-44d4-9f67-f997267a30a9&lang=es'
      // },
      {
        img: require('./images/es/iarc.png'),
        url: ''
      }
    ],
    footerTopLogo,
    agreementLinks: links
  },
  pt: {
    footerLeftLogo: [
      // {
      //   img: require('./images/pt/seal.png'),
      //   url: '//privacy.trustarc.com/privacy-seal/validation?rid=09956988-357a-458b-a77c-ccff6d4c0410&lang=pt-br'
      // },
      {
        img: require('./images/pt/iarc.png'),
        url: ''
      }
    ],
    footerTopLogo,
    agreementLinks: links
  },
  de: {
    footerLeftLogo: [
      // {
      //   img: require('./images/de/seal.png'),
      //   url: '//privacy.trustarc.com/privacy-seal/validation?rid=fc0812bb-a6e1-409d-913c-fe54525e522b&lang=de'
      // },
      {
        img: require('./images/de/iarc.png'),
        url: ''
      }
    ],
    footerTopLogo,
    agreementLinks: links
  },
  fr: {
    footerLeftLogo: [
      // {
      //   img: require('./images/fr/seal.png'),
      //   url: '//privacy.trustarc.com/privacy-seal/validation?rid=0cb01fac-c229-464c-b3a2-4c64273cd23a&lang=fr'
      // },
      {
        img: require('./images/fr/iarc.png'),
        url: ''
      }
    ],
    footerTopLogo,
    agreementLinks: links
  },
  ru: {
    footerLeftLogo: [
      // {
      //   img: require('./images/ru/seal.png'),
      //   url: '//privacy.trustarc.com/privacy-seal/validation?rid=7f13aee5-fbad-4177-a0be-9835a9de1f69&lang=ru'
      // },
      {
        img: require('./images/ru/iarc.png'),
        url: ''
      }
    ],
    footerTopLogo,
    agreementLinks: links
  },
  th: {
    footerLeftLogo: [
      // {
      //   img: '',
      //   url: ''
      // }
    ],
    footerTopLogo,
    agreementLinks: links
  }
};

export default Config;
